import React, { useEffect, useState, useRef } from 'react';
import { Icon } from '@iconify/react';
import { Input } from '../ui/Input';
const HEADING_FONT = "'RobotoCondensed VariableFont Wght', Roboto Condensed, sans-serif";
interface HeaderProps {
  onMenuClick?: () => void;
  commentMode?: boolean;
  onCommentModeToggle?: () => void;
  commentCount?: number;
  onCommentPanelToggle?: () => void;
}
export function Header({
  onMenuClick,
  commentMode = false,
  onCommentModeToggle,
  commentCount = 0,
  onCommentPanelToggle
}: HeaderProps) {
  const [commentMenuOpen, setCommentMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setCommentMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const hasComments = commentCount > 0;
  return <header className="fixed top-0 right-0 left-0 md:left-[260px] z-40 bg-[#EFF0F2]" style={{
    height: '64px'
  }} data-id="element-180">
      <div className="h-full bg-white flex items-center justify-between px-4 md:px-8 border border-[#E4E4E4]" data-id="element-181">
        {/* Hamburger — mobile only */}
        <button className="md:hidden flex items-center justify-center w-9 h-9 text-[#293B54] hover:bg-gray-100 rounded transition-colors flex-shrink-0" onClick={onMenuClick} aria-label="Apri menu" data-id="element-182">
          <Icon icon="tabler:menu-2" fontSize={22} data-id="element-183" />
        </button>

        <div className="w-full md:w-96 md:mr-auto" data-id="element-184">
          <Input placeholder="Cerca (Ctrl+z)" icon={<Icon icon="tabler:search" fontSize={18} data-id="element-186" />} className="border border-[#E4E4E4] bg-transparent focus:ring-0 rounded-full" data-id="element-185" />
        </div>

        <div className="flex items-center gap-1 flex-shrink-0" data-id="element-187">
          {/* Comments Button with Dropdown */}
          <div className="relative" ref={menuRef} data-id="element-188">
            <button onClick={() => setCommentMenuOpen(!commentMenuOpen)} className="relative flex items-center gap-1.5 transition-all duration-150" style={{
            padding: '6px 14px',
            borderRadius: '9999px',
            fontSize: '13px',
            fontFamily: HEADING_FONT,
            textTransform: 'uppercase',
            letterSpacing: '0.3px',
            cursor: 'pointer',
            backgroundColor: '#FFFFFF',
            color: '#293B54',
            border: '1px solid #293B54'
          }} data-id="element-189">
              <Icon icon="tabler:messages" fontSize={16} data-id="element-190" />
              <span className="hidden sm:inline" data-id="element-191">Note</span>
              {hasComments && <span style={{
              minWidth: '18px',
              height: '18px',
              borderRadius: '9px',
              backgroundColor: '#EA5455',
              color: 'white',
              fontSize: '10px',
              fontWeight: 600,
              fontFamily: HEADING_FONT,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0 4px',
              marginLeft: '2px'
            }} data-id="element-192">
                  {commentCount}
                </span>}
              <Icon icon="tabler:chevron-down" fontSize={14} style={{
              marginLeft: '2px'
            }} data-id="element-193" />
            </button>

            {commentMenuOpen && <div style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            marginTop: '6px',
            backgroundColor: 'white',
            borderRadius: '6px',
            boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
            border: '1px solid #EEEEEE',
            zIndex: 60,
            minWidth: '180px',
            overflow: 'hidden',
            padding: '4px 0'
          }} data-id="element-194">
                {hasComments && <button onClick={() => {
              setCommentMenuOpen(false);
              onCommentPanelToggle?.();
            }} className="w-full flex items-center gap-2.5 transition-colors hover:bg-[#F5F5F5]" style={{
              padding: '8px 14px',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              textAlign: 'left',
              fontSize: '14px',
              fontFamily: 'Roboto, sans-serif',
              color: '#293B54'
            }} data-id="element-195">
                    <Icon icon="tabler:messages" fontSize={16} style={{
                color: '#293B54',
                flexShrink: 0
              }} data-id="element-196" />
                    Apri note ({commentCount})
                  </button>}
                <button onClick={() => {
              setCommentMenuOpen(false);
              onCommentModeToggle?.();
            }} className="w-full flex items-center gap-2.5 transition-colors hover:bg-[#F5F5F5]" style={{
              padding: '8px 14px',
              border: 'none',
              background: commentMode ? '#F5F5F5' : 'transparent',
              cursor: 'pointer',
              textAlign: 'left',
              fontSize: '14px',
              fontFamily: 'Roboto, sans-serif',
              color: '#293B54'
            }} data-id="element-197">
                  <Icon icon="tabler:message-plus" fontSize={16} style={{
                color: '#293B54',
                flexShrink: 0
              }} data-id="element-198" />
                  {commentMode ? 'Disattiva modalità nota' : 'Aggiungi nota'}
                </button>
              </div>}
          </div>

          {/* User Menu */}
          <button className="flex items-center gap-2 text-gray-700 hover:text-navy-primary transition-colors ml-3" style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer'
        }} data-id="element-199">
            <Icon icon="tabler:user" fontSize={18} className="text-gray-500" data-id="element-200" />
            <span className="text-sm font-medium hidden sm:inline" data-id="element-201">
              Michael
            </span>
            <Icon icon="tabler:chevron-down" fontSize={16} data-id="element-202" />
          </button>
        </div>
      </div>
    </header>;
}